export default __webpack_public_path__ + "static/media/mindmap_05.fdb06a8a.png";